import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { DatabricksCopySource } from 'app/model/pipeline/copysource/databricks.copysource';
import { commonCopySourceAdapts, CopySourceAdapter } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ValueAdapter } from '../../value.adapter';
import { Model } from 'app/model/backendmodel';
import { LookupActivity } from 'app/model/pipeline/lookup.activity';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DatabricksCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        exportSettings: {
            type: '*',
            dateFormat: '*',
            timestampFormat: '*'
        }
    }
})
export class DatabricksCopySourceAdapter extends CopySourceAdapter<
    DatabricksCopySource,
    Model.DatabricksCopySource
> {
    protected override async _toResource(
        copySource: DatabricksCopySource
    ): Promise<Model.DatabricksCopySource> {
        const result = this._toTabularResource(copySource, adfModelTypeMap.databricks.copySourceType);
        if (!(copySource.owner instanceof LookupActivity)) {
            result.exportSettings = { type: adfModelTypeMap.databricks.exportSettings };
            result.exportSettings.dateFormat =
                ValueAdapter.toResource(copySource, DatabricksCopySource.DATE_FORMAT) || undefined;
            result.exportSettings.timestampFormat =
                ValueAdapter.toResource(copySource, DatabricksCopySource.TIMESTAMP_FORMAT) || undefined;
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.DatabricksCopySource,
        copyActivity: CopyActivity
    ): Promise<DatabricksCopySource> {
        const result = this._toTabularModel(resource, copyActivity, DatabricksCopySource.MODEL);
        const exportSettings = resource.exportSettings;
        if (exportSettings != null) {
            ValueAdapter.toModel(result, DatabricksCopySource.DATE_FORMAT, exportSettings.dateFormat);
            ValueAdapter.toModel(
                result,
                DatabricksCopySource.TIMESTAMP_FORMAT,
                exportSettings.timestampFormat
            );
        }
        return result;
    }
}
